import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparisonAtlas, comparisonCopy, comparisonOld } from '../data/content';
export function Comparison() {
  return <section className="w-full bg-blue-50 py-14 md:py-20" data-id="element-36" data-mp="1l7e237fp3hjs">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-37" data-mp="1l5umzk5rzcjl">
        <h2 className="mx-auto max-w-3xl text-center text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-38" data-mp="1pynsia92iowq">
          {comparisonCopy.title}
        </h2>

        <div className="mx-auto mt-10 grid max-w-4xl gap-4 md:grid-cols-2 md:gap-5" data-id="element-39" data-mp="1zw1uj4u8vb5i">
          <div className="rounded-2xl bg-white p-6 ring-1 ring-blue-100 md:p-7" data-id="element-40" data-mp="1zy4vul0ukqpj">
            <p className="text-xs font-extrabold uppercase tracking-widest text-blue-900/45" data-id="element-41" data-mp="23vssptm3otk2">
              {comparisonCopy.oldEyebrow}
            </p>
            <h3 className="mt-1 text-lg font-extrabold tracking-tight text-blue-900/60" data-id="element-42" data-mp="9kntr2lyl5b2">
              {comparisonCopy.oldLabel}
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-43" data-mp="el1qvpm0uuub">
              {comparisonOld.map(item => <li key={item} className="flex items-start gap-3 text-blue-900/60" data-id="element-44" data-mp="1m20eq7io2h4j">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-45" data-mp="1h97d3sihvowo" />
                  <span data-id="element-46" data-mp="1d96wq2bu53mz">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl bg-white p-6 shadow-lg ring-2 ring-blue-600 md:p-7" data-id="element-47" data-mp="18alyg8g58u16">
            <p className="text-xs font-extrabold uppercase tracking-widest text-blue-600" data-id="element-48" data-mp="24ya2jmjdem1q">
              {comparisonCopy.atlasEyebrow}
            </p>
            <h3 className="mt-1 text-lg font-extrabold tracking-tight text-slate-900" data-id="element-49" data-mp="1vywosho7rbb7">
              {comparisonCopy.atlasLabel}
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-50" data-mp="1qz0l6jjfhlw6">
              {comparisonAtlas.map(item => <li key={item} className="flex items-start gap-3 font-semibold text-blue-800" data-id="element-51" data-mp="kkrhpfspelbn">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-emerald-600" aria-hidden="true" data-id="element-52" data-mp="fjlpdj2yh02n" />
                  <span data-id="element-53" data-mp="h2vj8b25dg0d">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-2xl font-extrabold italic leading-snug tracking-tight text-blue-600 md:text-3xl" data-id="element-54" data-mp="m0di18mgaeun">
          {comparisonCopy.closing}
        </p>
      </div>
    </section>;
}